import { getOrderTaskApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    BindOrderTaskRequest,
    CancelTaskRequest,
    OrderTaskApiFindOrderForTaskRequest,
    OrderForTaskResponse,
    OrderTaskResponse,
    PayForTaskRequest,
} from '@/core/generated/api';

/** Предоставляет операции со сделкой к заданию */
export const orderTaskService = {
    /** Находит заказ без сделки по точному номеру либо идентификатору */
    async findOrder(
        request: OrderTaskApiFindOrderForTaskRequest
    ): Promise<OrderForTaskResponse | null> {
        try {
            const response = await getOrderTaskApi().findOrderForTask(request);

            return response.data || null;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает сделку Rocket Work и связывает её с заказом */
    async bind(request: BindOrderTaskRequest): Promise<OrderTaskResponse> {
        try {
            const response = await getOrderTaskApi().bindOrderTask({ bindOrderTaskRequest: request });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает сделку по идентификатору заказа */
    async getByOrderId(orderId: string): Promise<OrderTaskResponse> {
        try {
            const response = await getOrderTaskApi().getByOrderId({ orderId });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Загружает сделку по номеру задания */
    async getByTaskId(taskId: number): Promise<OrderTaskResponse> {
        try {
            const response = await getOrderTaskApi().getByTaskId({ taskId });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Отменяет сделку к заданию */
    async cancel(request: CancelTaskRequest): Promise<void> {
        try {
            await getOrderTaskApi().cancelTask({ cancelTaskRequest: request });
        } catch (error: unknown) {
            rethrowHandledApiError(error);
        }
    },

    /** Направляет выплату исполнителю */
    async pay(request: PayForTaskRequest): Promise<void> {
        try {
            await getOrderTaskApi().payForTask({ payForTaskRequest: request });
        } catch (error: unknown) {
            rethrowHandledApiError(error);
        }
    },
};
